<section class="notifications">
  <div class="notifications__header-wrapper">
    <h3 class="notifications__header">
      {{ 'user-profile.notifications.title' | translate }}
    </h3>
    <p class="notifications__description">
      {{ 'user-profile.notifications.description' | translate }}
    </p>
  </div>

  <div class="notifications__options-table-wrapper">
    <table class="notifications__table" mat-table [dataSource]="dataSource">
      @for (column of columns; track column.id; let columnIndex = $index) {
        <ng-container [matColumnDef]="column.id">
          <th class="notifications__header-cell" mat-header-cell *matHeaderCellDef>
            {{ column.label | translate }}
          </th>
          <td class="notifications__cell" mat-cell *matCellDef="let element; let rowIndex = index">
            @if (!columnIndex) {
              <p class="notifications__type">
                {{ element[column.id] | translate }}
              </p>
              @if (column.id === 'title' && rowIndex > 0) {
                <p class="notifications__description">
                  {{ 'user-profile.notifications.table.type.orderUpdates.description' | translate }}
                </p>
              }
            } @else {
              <mat-slide-toggle
                class="notifications__slider"
                [checked]="element[column.id]"
                [hideIcon]="true"
              />
            }
          </td>
        </ng-container>
      }

      <tr class="notifications__header-row" mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr class="notifications__row" mat-row *matRowDef="let row; columns: displayedColumns"></tr>
    </table>
  </div>
</section>

<section class="subscription">
  <div class="subscription__text-block">
    <h3 class="subscription__title">
      {{ 'user-profile.notifications.subscription.title' | translate }}
    </h3>
    <p class="subscription__description">
      {{ 'user-profile.notifications.subscription.description' | translate }}
    </p>
  </div>
  <div class="subscription__email-block">
    <input
      class="subscription__input-email"
      type="email"
      [formControl]="emailControl"
      [placeholder]="'user-profile.notifications.subscription.emailPlaceholder' | translate"
    />
    <button
      class="btn-primary subscription__subscribe-btn"
      (click)="subscribe()"
      [disabled]="emailControl.invalid || emailControl.pristine"
    >
      {{ 'user-profile.notifications.subscription.subscribe' | translate }}
    </button>
  </div>
</section>
